// vue实例
let utilVue = {
  obj: null
};

export {utilVue};

export function successMsg(msg) {
  utilVue.obj.$message({
    showClose: true,
    message: msg,
    type: 'success'
  })
}

export function warningMsg(msg) {
  utilVue.obj.$message({
    showClose: true,
    message: msg,
    type: 'warning'
  })
}

export function msg(msg) {
  utilVue.obj.$message({
    showClose: true,
    message: msg,
  })
}

export function errorMsg(msg) {
  utilVue.obj.$message({
    showClose: true,
    message: msg,
    type: 'error'
  })
}
